export default "__VITE_ASSET__DQFc3cDl__"